/** Free / public mailbox providers and disposable domains — not accepted as a work email. */
export const BLOCKED_EMAIL_DOMAINS = new Set([
  // public mailboxes
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "ymail.com",
  "rocketmail.com",
  "outlook.com",
  "outlook.co.uk",
  "hotmail.com",
  "hotmail.co.uk",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "pm.me",
  "gmx.com",
  "gmx.de",
  "gmx.net",
  "web.de",
  "zoho.com",
  "fastmail.com",
  "hushmail.com",
  "tutanota.com",
  "tuta.io",
  "mail.com",
  "email.com",
  "inbox.com",
  "mail.ru",
  "bk.ru",
  "inbox.ru",
  "list.ru",
  "internet.ru",
  "yandex.ru",
  "yandex.com",
  "yandex.ua",
  "ya.ru",
  "rambler.ru",
  "ukr.net",
  "i.ua",
  "meta.ua",
  "bigmir.net",
  "online.ua",
  "email.ua",
  "wp.pl",
  "o2.pl",
  "onet.pl",
  "interia.pl",
  "op.pl",
  "tlen.pl",
  "seznam.cz",
  "abv.bg",
  "qq.com",
  "163.com",
  "126.com",
  "sina.com",
  "sohu.com",
  "naver.com",
  "daum.net",
  "hanmail.net",
  "rediffmail.com",
  "rediff.com",
  "sify.com",
  "indiatimes.com",
  "bol.com.br",
  "uol.com.br",
  "terra.com.br",
  "libero.it",
  "virgilio.it",
  "tiscali.it",
  "orange.fr",
  "laposte.net",
  "free.fr",
  "sfr.fr",
  "wanadoo.fr",
  "t-online.de",
  "freenet.de",
  "bluewin.ch",
  "telenet.be",
  "ziggo.nl",
  "hotmail.fr",
  "hotmail.it",
  "hotmail.es",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.it",
  "yahoo.es",
  "yahoo.com.br",
  "mynet.com",
  "hotmail.com.tr",
  // disposable
  "mailinator.com",
  "10minutemail.com",
  "tempmail.com",
  "temp-mail.org",
  "guerrillamail.com",
  "sharklasers.com",
  "yopmail.com",
  "trashmail.com",
  "getnada.com",
  "dispostable.com",
  "maildrop.cc",
  "throwawaymail.com",
  "fakeinbox.com",
  "mailnesia.com",
  "spambog.com",
  "moakt.com",
  "emailondeck.com",
  "mail-temp.com",
  "mohmal.com",
  "tempmailo.com",
  "burnermail.io",
  "anonaddy.com",
  "simplelogin.com",
  "duck.com",
]);

export const WORK_EMAIL_MESSAGE = "Please use your company email address.";
export const INVALID_EMAIL_MESSAGE = "Enter a valid email address.";

export function emailDomain(email: string): string {
  return email.trim().toLowerCase().split("@")[1] ?? "";
}

export function isWorkEmail(email: string): boolean {
  const domain = emailDomain(email);
  if (!domain || !domain.includes(".")) return false;
  return !BLOCKED_EMAIL_DOMAINS.has(domain);
}

/** Returns an error message, or null when the email is a valid work email. */
export function validateWorkEmail(email: string): string | null {
  const value = email.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) return INVALID_EMAIL_MESSAGE;
  return isWorkEmail(value) ? null : WORK_EMAIL_MESSAGE;
}
